<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <span class="title-small-bold text-primary-color">
      {{ config.data.emergencyDialog ? "Emergency Alert Details" : "Map" }}
    </span>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="map -mx-spacing-3xl">
  @if (config.data.emergencyDialog && config.data.emergencyDetails) {
    <div class="emergency-details flex align-items-center gap-spacing-xs background-muted-danger-bg label-medium-medium text-danger-color py-spacing-xl px-spacing-3xl">
      <i class="icon-warning size-icon-md"></i>
      {{ config.data.emergencyDetails }}
    </div>
  }
  <div class="map-card">
    <app-ride-details-map-pro
      [rideStops]="rideTimelineData()"
      [rideId]="config.data.docRide?.id ?? 0"
      [ownerContext]="'dialog-' + instanceId"
      [enableLiveTracking]="mappedRideData()?.enableLiveTracking ?? false"
      [displayDriverLocation]="config.data.showRideTimeline"
      [rideDOT]="config.data.rideDOT"
      [timezoneOffsetInSeconds]="mappedRideData()?.timezoneOffsetInSeconds">
    </app-ride-details-map-pro>
  </div>
  @if (config.data.emergencyDialog) {
    <div class="flex justify-content-between background-muted-tertiary-bg px-spacing-3xl py-spacing-md">
      <span class="instruction-title label-medium-medium">What to do: </span>
      <ul class="mb-0">
        <li class="label-medium-medium">Alert your supervisor.</li>
        <li class="label-medium-medium">Inform the school district and the parents.</li>
      </ul>
      <ul class="mb-0">
        <li class="label-medium-medium">Call the driver.</li>
        <li class="label-medium-medium">Call 911 if needed.</li>
      </ul>
    </div>
  }
</div>

@if (config.data.showRideTimeline) {
  <div class="ride-timeline-container">
    <div class="ride-timeline my-spacing-xl border-round-xl overflow-hidden border-1 border-neutral-base-primary-border">
      <div class="grid grid-nogutter">
        <div class="col-12 flex align-items-center border-bottom-1 border-neutral-base-primary-border">
          <div class="col-3 md:col-2 title px-spacing-3xl py-spacing-md border-right-1 border-neutral-base-primary-border">
            <span class="text-sm">Driver</span>
          </div>
          <div class="col-9 md:col-10 info py-spacing-md px-spacing-3xl">
            <div class="flex align-items-center gap-spacing-md">
              <p-avatar
                class="blue-100 border-round-lg relative"
                [label]="config.data.driverDetails.name[0]"
                size="large">
                <span
                  [ngClass]="{ active: config.data.driverDetails.online || false }"
                  class="avatar-status"></span>
              </p-avatar>
              <div class="flex flex-column justify-content-center">
                <span>{{ config.data.driverDetails.name }}</span>
                @if (config.data.driverDetails.id != "108179") {
                  <span
                    class="text-link-color cursor-pointer"
                    (click)="openContractorDialog()"
                    (keydown.enter)="openContractorDialog()">
                    #{{ config.data.driverDetails.id }}
                  </span>
                }
              </div>
            </div>
          </div>
        </div>

        @if (!config.data.emergencyDialog) {
          <div class="col-12 flex align-items-center">
            <div class="col-3 md:col-2 title px-spacing-3xl py-spacing-md border-right-1 border-neutral-base-primary-border">
              <span class="text-sm">Stops</span>
            </div>
            <div class="col-9 md:col-10 flex-grow-1 info py-spacing-md px-spacing-xs">
              <div class="stops-container">
                <app-stepper
                  [steps]="rideTimelineData()"
                  [activeStep]="config.data.rideStatus | activeStep: rideTimelineData()"></app-stepper>
              </div>
            </div>
          </div>
        } @else {
          <div class="col-12 flex align-items-center">
            <div class="col-3 md:col-2 title px-spacing-3xl py-spacing-md border-right-1 border-neutral-base-primary-border">
              <span class="text-sm">Blueprint</span>
            </div>
            <div class="col-9 md:col-10 info py-spacing-md px-spacing-3xl">
              <div class="flex gap-spacing-md align-items-center">
                <p-avatar
                  class="blue-lighter overflow-hidden border-1 border-round-md form-border-brand-active-border"
                  icon="icon-blueprint"
                  size="large" />
                <div class="flex flex-column">
                  <ul class="pl-spacing-xl m-0">
                    @for (client of mappedRideData()?.clientDetails; track $index) {
                      <li>
                        <span style="margin-left: -0.25rem">{{ client.name }}</span>
                      </li>
                    }
                  </ul>
                  <a
                    (click)="openBlueprintDialog()"
                    class="text-link-color cursor-pointer no-underline"
                    >#{{ mappedRideData()?.blueprintId }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (!config.data.emergencyDialog) {
  @if (stopsTableData().length > 0) {
    <p-table
      #table
      [value]="stopsTableData()"
      [columns]="columns"
      dataKey="id"
      [tableStyleClass]="'table-main-mode border-round-lg'"
      appendTo="body">
      <ng-template
        #header
        let-columns>
        <tr>
          @for (col of columns; track $index) {
            <th
              [class]="'Utilities-Uppercase-sm-semi text-caption-color ' + col.field"
              scope="col">
              <span>{{ col.name }}</span>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template
        #body
        let-rowData
        let-columns="columns"
        let-index="rowIndex">
        <tr>
          @for (col of columns; track $index) {
            <td>
              @if (col.field == "place") {
                <div class="flex gap-spacing-sm align-items-center">
                  <app-badge
                    [value]="(index + 1).toString()"
                    size="large"
                    [severityClass]="rowData['status'].severity">
                  </app-badge>
                  <span class="table-text-item label-medium-regular text-primary-color">
                    {{ rowData["place"] }}
                  </span>
                </div>
              } @else if (col.field == "status") {
                <app-tag
                  class="ride-status-tag-sm"
                  [content]="rowData['status'].type"
                  sizeClass="tag-sm"
                  styleClass="bold"
                  [severityClass]="rowData['status'].severity">
                </app-tag>
              } @else if (col.field == "actualArrivalTime") {
                <div>
                  <span
                    class="label-medium-regular mr-spacing-3xs"
                    [ngClass]="{ 'text-lightest-color': rowData['actualArrivalTime'].time == 'N/A' || rowData['actualArrivalTime'].time == 'Pending...' }">
                    {{ rowData["actualArrivalTime"].time }}
                  </span>
                  @if (rowData["actualArrivalTime"].description && rowData["actualArrivalTime"].description.toLowerCase() != "skipped") {
                    <span
                      class="label-medium-regular"
                      [ngClass]="{
                        'text-danger-color': rowData['actualArrivalTime'].arrivalTimeStatus === 'late',
                        'text-success-color': rowData['actualArrivalTime'].arrivalTimeStatus === 'early'
                      }">
                      {{ rowData["actualArrivalTime"].description }}
                    </span>
                  }
                </div>
              } @else if (col.field == "students") {
                <div class="flex flex-column gap-spacing-sm justify-content-between h-full">
                  @for (student of rowData["students"]; track $index) {
                    <div class="student-full-row flex gap-spacing-3xl align-items-center justify-content-between">
                      <div class="flex gap-spacing-xs align-items-center">
                        <i
                          class="pi size-icon-md icon-lightest-color"
                          [ngClass]="{
                            'icon-arrow-circle-up-right-solid': student.actionType.toLowerCase() === 'pick-up',
                            'icon-arrow-circle-down-right-solid': student.actionType.toLowerCase() === 'drop-off'
                          }">
                        </i>
                        <span class="table-text-item label-medium-regular text-primary-color">{{ student.name }}</span>
                      </div>

                      @if (student.status) {
                        <div class="flex gap-spacing-xs align-items-center">
                          <i
                            class="pi"
                            [ngClass]="{
                              'icon-x icon-lightest-color': student.status.toLowerCase() === 'no-show',
                              'icon-check icon-success-color': student.status.toLowerCase() != 'no-show'
                            }">
                          </i>
                          <span
                            class="label-medium-regular"
                            [ngClass]="{
                              'text-light-color': student.status.toLowerCase() === 'no-show',
                              'text-success-color': student.status.toLowerCase() != 'no-show'
                            }">
                            {{ student.status }}
                          </span>
                        </div>
                      } @else {
                        <div class="flex">
                          <span class="label-medium-regular text-lightest-color">Pending...</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <span
                  class="label-medium-regular"
                  [ngClass]="{ 'text-lightest-color': rowData[col.field] == 'N/A' || rowData[col.field] == 'Pending...' }">
                  {{ rowData[col.field] }}
                </span>
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-no-records></app-no-records>
  }
}

<div class="p-dialog-footer pt-spacing-3xl px-0 footer">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  @if (config.data.emergencyDialog) {
    <app-button
      label="Acknowledge"
      (btnClick)="acknowledgeRideEmergency()"
      sizeClass="p-button-md"
      severity="primary"></app-button>
  }
</div>
